// @flow

import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Intro from './Intro';
import Services from './Services';
import LocationContacts from './LocationContacts';
import ParalaxScroller from '../../../components/paralaxScroller/ParalaxScroller';
import MenuPage from '../../../components/paralaxScroller/MenuPage';
import { parseUrl } from '../../../utils/urlUtils';
import type { Office } from '../../../types/OfficesType';
import BuildingDescription from './BuildingDescription';
import { fetchOfficesMedias } from '../../../state/offices/officesService';
import KeyFacts from './KeyFacts';
import Floors from './Floors';
import OfficeDescription from './OfficeDescription';
import Loader from '../../common/Loader';

type Props = {
  office: Office,
  location: Location,
}


class OfficeData extends React.Component<Props> {
  static defaultProps = {
    selectedBuilding: null,
  };

  params = () => parseUrl(this.props.location.search);

  render() {
    if (!this.props.office) {
      return <Loader isLoading />;
    }
    const { buildingId } = this.params();
    const selectBuilding = (buildingId && this.props.office.buildingList) ? this.props.office.buildingList.filter(building => building.buildingId === buildingId)[0] : null;
    return (
      <ParalaxScroller
        className="scrollable-content"
        scrollSelf
      >
        <div className="office mall-datas">
          <MenuPage id="intro">
            <Intro
              selectedBuildingId={buildingId || this.props.office.buildingList && this.props.office.buildingList.length > 0 && this.props.office.buildingList[0].buildingId}
            />
          </MenuPage>
          <MenuPage id="factFigure">
            <KeyFacts
              characteristics={selectBuilding
                ? selectBuilding.characteristics
                : this.props.office.characteristics}
              keyFactCells={selectBuilding
                ? selectBuilding.keyFactCells
                : null}
            />
          </MenuPage>
          <MenuPage id="office-description">
            {
              !selectBuilding &&
              <OfficeDescription office={this.props.office} />
            }
          </MenuPage>
          <MenuPage id="description" className="service-description-container">
            {
              selectBuilding &&
              <>
                <BuildingDescription
                  sustainableDevelopment={selectBuilding.sustainableDevelopment}
                  technicalDescription={selectBuilding.technicalDescription}
                  tenants={selectBuilding.tenants}
                  buildingDescription={selectBuilding.buildingDescription}
                />
                <Services services={selectBuilding.services} />
              </>
            }
          </MenuPage>
          <MenuPage id="floor">
            {
              selectBuilding &&
              <Floors floors={selectBuilding.floors} />
            }
          </MenuPage>
          <MenuPage id="contact">
            {
              selectBuilding &&
              <LocationContacts office={this.props.office} building={selectBuilding} />
            }
          </MenuPage>
        </div>
      </ParalaxScroller>
    );
  }
}

export default withRouter(connect(state => ({
  dynamicKeysList: state.dynamicKeys.dynamicKeysList,
}), {
  fetchOfficesMedias,
})(OfficeData));
